module.exports = __webpack_public_path__ + "img/portrait-rank-8@3x.6fd956be.png";